// Decodifica JWT senza librerie (app-agnostico): base64url → JSON dei claim.
// Usato sia da SessionStore (username/iat/exp) sia dall'app per claim custom.

export function decodeBase64Url(value: string): string {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

/** Payload (claim) del JWT, o `null` se il token è malformato. */
export function decodeJwtClaims<T = Record<string, unknown>>(token: string): T | null {
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    return JSON.parse(decodeBase64Url(parts[1])) as T;
  } catch {
    return null;
  }
}
